<template>
  <div class="async-component-container">
    <component :is="asyncComponent"></component>
  </div>
</template>

<script>
import DanmakuModuleMixin from '../mixins/DanmakuModuleMixin.js'

export default {
  data () {
    return {
      loading: true,
      styleId: '',
      asyncComponent: '',
      noticeService: null,
      scriptURL: '',
      stylesheetURL: '',
      reloadNoticeURL: ''
    }
  },
  props: {
    script: {
      type: String,
      default: ''
    },
    stylesheet: {
      type: String,
      default: ''
    },
    reloadNotice: {
      type: String,
      default: ''
    }
  },
  watch: {
    script (val) {
      this.scriptURL = val
      this.reload()
    },
    stylesheet (val) {
      this.stylesheetURL = val
      this.reload()
    },
    reloadNotice (val) {
      this.reloadNoticeURL = val
      this.connectReloadNoticeServer()
    }
  },
  created () {
    this.scriptURL = this.script
    this.stylesheetURL = this.stylesheet
    this.reloadNoticeURL = this.reloadNotice
    this.loadComponentResource()
    this.connectReloadNoticeServer()
  },
  destroyed () {
    this.removeStylesheet(this.styleId)
    if (this.noticeService) {
      this.noticeService.close()
    }
  },
  methods: {
    loadComponentResource () {
      // Inject Stylesheet
      if (this.stylesheetURL) {
        let style = document.createElement('link')
        style.href = this.stylesheetURL
        style.rel = 'stylesheet'
        style.id = this.styleId = `async-component-style-${new Date().getTime()}`
        document.querySelector('head').appendChild(style)
      }
      // Load component
      if (this.scriptURL) {
        return window.fetch(this.scriptURL).then(res => res.text()).then(cjs => {
          let injectModule = {
            exports: {}
          }
          /* eslint-disable no-new-func */
          new Function('module', 'exports', cjs)(injectModule, injectModule.exports)
          if (injectModule.exports && injectModule.exports.default) {
            injectModule = injectModule.exports.default
          } else {
            injectModule = injectModule.exports
          }
          if (injectModule.mixins && injectModule.mixins.length) {
            injectModule.mixins.push(DanmakuModuleMixin)
          } else {
            injectModule.mixins = [ DanmakuModuleMixin ]
          }
          this.asyncComponent = injectModule
          this.loading = false
        })
      } else {
        return Promise.resolve()
      }
    },
    removeStylesheet (styleId) {
      if (styleId) {
        let link = document.querySelector(`#${styleId}`)
        if (link) {
          link.remove()
        }
      }
    },
    loadConfig (config = {}) {
      this.scriptURL = config.script || ''
      this.stylesheetURL = config.stylesheet || ''
      this.reloadNoticeURL = config.reloadNotice || ''
      this.reload()
      this.connectReloadNoticeServer()
    },
    reload () {
      this.loading = true
      let styleId = this.styleId
      this.loadComponentResource().then(() => {
        this.removeStylesheet(styleId)
      })
    },
    connectReloadNoticeServer () {
      if (!this.reloadNoticeURL) return
      if (this.noticeService) {
        this.noticeService.close()
      }
      this.noticeService = new WebSocket(this.reloadNoticeURL)
      this.noticeService.addEventListener('message', (e) => {
        if (e.data === 'reload') {
          this.reload()
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.async-component-container
  position relative
  flex 1
  display flex
  flex-direction column
</style>



// WEBPACK FOOTER //
// src/components/AsyncComponent.vue